<div *ngIf="displayMaxSavedCartErrorMsg">
  <vs-custom-global-cart-msg></vs-custom-global-cart-msg>
</div>
<ng-container *ngIf="cart$ | async as cart; else cartSpinner">
  <ng-container *ngIf="cart.totalItems > 0; else noCartEntries">
    <ng-container>
      <div class="row m-0 background-shade">
        <div class="col-md-7 order-actions-container">
          <vs-order-actions
            [userType]="userType"
            [cart$]="cart$"
            (scrollToEntry)="scrollCartEntryIntoView($event)"
            (updateCart)="reloadCart($event)"
          >
          </vs-order-actions>
        </div>

        <div class="col-md-5 order-summary-container pr-0">
          <vs-order-summary
            [cart$]="cart$"
            [userType]="userType"
            (scrollToEntry)="scrollCartEntryIntoView($event)"
          >
          </vs-order-summary>
        </div>
      </div>
      <ng-container
        *ngIf="
          cart.totalItems < 150 &&
          (cart.quoteCartType == QuoteStatus.ADDITIONALFULL ||
            cart.quoteCartType == QuoteStatus.ADDITIONALPARTIAL)
        "
      >
        <div class="row m-0 background-shade">
          <a
            (click)="addMoreProduct = !addMoreProduct"
            class="cart-entry-text-bold add-product-link"
          >
            <i *ngIf="!addMoreProduct" class="material-icons"
              >keyboard_arrow_down</i
            >
            <i *ngIf="addMoreProduct" class="material-icons"
              >keyboard_arrow_up</i
            >
            {{ 'addCart.addMoreProducts' | cxTranslate }}
          </a>
        </div>
        <ng-container *ngIf="addMoreProduct">
          <div class="m-0 add-more-product">
            <div class="label">
              {{ 'bulkorder.uploadpastelabel' | cxTranslate }}
            </div>
            <textarea
              class="upload-content"
              placeholder="{{
                'bulkorder.uploadtypeplaceholder' | cxTranslate
              }}"
              [(ngModel)]="content"
              name="content"
              (keyup)="partEntered()"
              (ngModelChange)="stopCount($event)"
            ></textarea>
            <div *ngIf="showTextError" class="text-danger">
              {{ 'bulkorder.uploadppartno' | cxTranslate }}
            </div>
            <div *ngIf="incorrectNo" class="text-danger">
              {{ 'bulkorder.uploadpartnumbertext' | cxTranslate }}
            </div>
            <div class="d-flex">
              <button
                type="submit"
                class="vs-primary-btn paste-btn"
                [disabled]="!content"
                (click)="uploadContent()"
              >
                <span>{{ 'addCart.addProductsBtn' | cxTranslate }}</span>
              </button>
              <button
                type="reset"
                class="vs-tertiary-btn cancel-btn"
                (click)="cancel()"
              >
                {{ 'addCart.cancelBtn' | cxTranslate }}
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="entries$ | async as entries">
      <div *ngIf="cart.totalItems > 0" class="cart-details-wrapper row m-0">
        <vs-cart-item-list
          [items]="entries"
          [hasHeader]="true"
          [cartIsLoading]="!(cartLoaded$ | async)"
          [userType]="userType"
          [cart]="cart"
          (cartEntryList)="setCartEntryList($event)"
        ></vs-cart-item-list>
      </div>
    </ng-container>

    <ng-container>
      <div class="row cart-detail-bottom">
        <div class="col-md-7"></div>

        <div class="col-md-5 pr-0">
          <vs-order-summary
            [cart$]="cart$"
            [userType]="userType"
            (scrollToEntry)="scrollCartEntryIntoView($event)"
          >
          </vs-order-summary>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #noCartEntries>
    <vs-empty-cart
      [nonSellableProd]="cart.vsNonSellableProducts"
      *ngIf="!isLoading"
    ></vs-empty-cart>
  </ng-template>
</ng-container>

<ng-template #cartSpinner>
  <cx-spinner></cx-spinner>
</ng-template>

<!-- [routerLink]="{ cxRoute: '/cartCheckout' } | cxUrl" -->
<!-- (click)="proceedToCheckout()" -->
<!-- <ng-container *ngIf="cart$ | async as cart">
  <ng-container *ngIf="entries$ | async as entries">
    <div *ngIf="cart.totalItems > 0" class="cart-details-wrapper">
      <div class="cx-total">
        {{ 'cartDetails.cartName' | cxTranslate: { code: cart.code } }}
      </div>

      <ng-container *ngIf="orderPromotions$ | async as orderPromotions">
        <cx-promotions [promotions]="orderPromotions"></cx-promotions>
      </ng-container>

      <cx-cart-item-list
        [items]="entries"
        [cartIsLoading]="!(cartLoaded$ | async)"
        [promotionLocation]="promotionLocation"
        [options]="{
          isSaveForLater: false,
          optionalBtn: saveForLaterBtn
        }"
      ></cx-cart-item-list>
    </div>
  </ng-container>
</ng-container>

<ng-template let-ctx #saveForLaterBtn>
  <div
    *ngIf="selectiveCartEnabled"
    class="col-md-3 col-lg-3 col-xl-3 cx-sfl-btn"
  >
    <button
      class="link cx-action-link"
      [disabled]="ctx.loading"
      (click)="saveForLater(ctx.item)"
      type="button"
    >
      {{ 'saveForLaterItems.saveForLater' | cxTranslate }}
    </button>
  </div>
</ng-template>
 -->
